import { Injectable } from '@angular/core';
import { ConfigService } from './../../config/config/config.service';
import { LoginService } from './../../services/login/login.service';

@Injectable()
export class TealiumdataService {
  constructor(private config: ConfigService, private auth: LoginService) {
  }

  public init(url: string): string[] {
    const sections = [];
    const parts = url.split('/');
    parts[0] = 'cvs|' + this.detectAdobePlatform();

    sections[0] = parts[0];

    for (let i = 1; i < 5; i++) {
      sections[i] = parts.length > i ? parts.slice(0, (i + 1)).join('|') : sections[i - 1];
    }
    return sections;
  }

  private detectLanguage(): string {
    return location.pathname.split('/')[0] === 'sdm'
      || !!location && location.host.indexOf('es') === 0 ? 'es' : 'en';
  }

  private detectAdobePlatform(): string {
    const form = this.config.getForm();
    switch (form) {
      case 'TABLET':
        return 'tweb';
      case 'MOBILE':
        return this.config.getSource().endsWith('APP') ? 'mapp' : 'mweb';
      default:
        return 'dweb';
    }
  }

  public getDefault(existingUdo?: any, page?: string, cat?: string) {
    let defaultUdo;
    const state_authentication = false;
    const timestamp = new Date().toLocaleString('en-US', {timeZone: 'UTC'});

    if (existingUdo) {
      defaultUdo = existingUdo;
    } else {
      const sections = this.init(location.hash ?
        location.pathname + location.hash :
        location.pathname);
      defaultUdo = {
        domain: document.domain,
        adobe_page_name: sections[4] + '|' + page,
        page_name: page,
        page_category: cat,

        sub_section1: sections[1],
        sub_section2: sections[2],
        sub_section3: sections[3],
        sub_section4: sections[4],

        hierarchy: sections[4],
        page_url: document.URL,
        previous_page_url: document.referrer,
        state_authentication: this.auth.getSSOCookieValues() ? 'true' : 'false',
        state_logged_in: this.auth.getSSOCookieValues() ? 'true' : 'false',
        environment: this.config.getTealiumEnv(),

        language: this.detectLanguage(),
        country: 'US',
        currency: 'USD',
        platform: this.detectAdobePlatform(),
        time_stamp: timestamp
        // momenttz().tz('America/New_York').format('MM/DD/YYYY h:mm a z')
      };
    }
    return defaultUdo;
  }
}
